import { ClockIcon } from "@moznsystems/mozn-ui";
import { Tag } from "./tag";
import { FC } from "react";

export const OnHoldTag: FC<{ label?: string }> = ({ label = "On Hold" }) => {
	return (
		<Tag
			className="mt-1 justify-self-start"
			variant="hold"
			endIcon={<ClockIcon />}
		>
			{label}
		</Tag>
	);
};
